import { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import useLocaleUpdater from '@frolight/hooks/useLocaleUpdater';
import useUserPreferences from '@frolight/hooks/useUserPreferences';

import i18n, { initializeI18n } from '@frolight/i18n';

export const I18nProvider  = ({ children }) => {
  const [ isInitialized, setIsInitialized ] = useState(false);

  const { updateLocaleIfNeeded } = useLocaleUpdater();
  const { userPreferences, setUserPreferences } = useUserPreferences(); 

  useEffect(() => {
    const abortController = new AbortController();
    let mounted = true;

    const init = async () => {
      await initializeI18n(abortController);
      if (mounted) {
        setIsInitialized(true);
      }
    }

    init();
  
    return () => {
      abortController.abort();
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (userPreferences.locale) {
      const updatedLocale = updateLocaleIfNeeded(userPreferences.locale);
      if (updatedLocale) {
        setUserPreferences({ locale: updatedLocale, temperatureUnit: userPreferences.temperatureUnit });
      }
    }
  }, [ userPreferences ]);

  if (!isInitialized) {
    return <p>Loading&hellip;</p>;
  }

  return <I18nextProvider i18n={ i18n }>{ children }</I18nextProvider>;
};
